(function(){
    angular
        .module('appback')
        .directive('ngBigchat', ngBigchat);

        ngBigchat.$inject = ['socket','$timeout'];
        function ngBigchat(socket,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/templateresultados?name=bigchat.twig',
		        scope: {
                  //ngModel : '=',
                  //rc: '=',
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {

			        });
		        }
          }
      }
})();